<template>
  <div class="ff-loading">
    <svg class="svg" viewBox="0 0 177 194" fill="none">
      <path class="node-1" d="M176.106 96.9911C176.106 145.622 136.684 167.434 88.0532 167.434C39.4228 167.434 0 145.622 0 96.9911C0 48.3607 39.4228 26.5486 88.0532 26.5486C136.684 26.5486 176.106 48.3607 176.106 96.9911Z"/>
      <path class="node-2" d="M75.8259 9.80371C123.983 3.03566 151.069 39.0391 157.838 87.1963C164.606 135.353 148.492 177.428 100.335 184.196C52.178 190.964 25.0915 154.961 18.3235 106.804C11.5554 58.6465 27.6687 16.5718 75.8259 9.80371Z" style="mix-blend-mode:multiply"/>
    </svg>
    <aside v-if="text" class="ff-loading__message">
      {{text}}
    </aside>
  </div>
</template>

<script>
const SAVED_STALL = 2000
export default {
  name: 'ff-loading',
  props: [
    'loading',
    'text'
  ],
  data () {
    return {
      saved: false
    }
  },
  computed: {
    active () {
      if (this.loading) return true
      this.activate()
      return false
    }
  },
  methods: {
    activate () {
      this.saved = true
      setTimeout(()=>{
        this.saved = false
      }, SAVED_STALL)
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";

  .ff-loading {
    font-size: $fontSize-normal;
    margin-bottom: $unit-1;
    max-width: $maxWidth;
    margin: auto;
  }

  @keyframes rotate-forward {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes rotate-backward {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(-360deg);
    }
  }

  @keyframes activate {
    0% {
      transform: translate3d(0, .75rem, 0);
      opacity: 0;
    }
    10% {
      opacity: 1;
    }
    100% {
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }
  }

  @keyframes ellipsis {
    to {
      width: .8em;
    }
  }

  .svg {
    display: block;
    max-width: $fontSize-large*2;
    margin: $unit-2 auto;
  }

  .node-1,
  .node-2 {
    transform-origin: center;
    mix-blend-mode: multiply;
  }

  .node-1 {
    animation: rotate-forward 1.25s cubic-bezier(.33,.35,.78,.94) infinite;
    fill: $color-main;
  }

  .node-2 {
    animation: rotate-backward .75s cubic-bezier(.33,.35,.78,.94) infinite;
    fill: $color-secondary;
  }

  .ff-loading__message {
    transform-origin: center;
    animation: activate 5.75s cubic-bezier(.33,.35,.78,.94);
    font-size: $fontSize-normal;
    text-align: center;
    position: relative;

    &::after {
      margin-left: .15em;
      position: absolute;
      overflow: hidden;
      display: inline-block;
      vertical-align: bottom;
      animation: ellipsis steps(4,end) 1500ms infinite;
      content: "\2026"; /* ascii code for the ellipsis character */
      width: 0px;
      opacity: 0.5;
    }
  }

</style>
